import { removeLeadingWhitespace } from "../../snippets/utils/snippets";

export const cleanUpWhitespace = (text: string): string => {
  // Replace lines followed by whitespace with a single newline
  const cleanedText = text.replace(/\s*\n\s*/g, "\n");

  // Replace remaining whitespace with a single space
  return cleanedText.replace(/\s+/g, " ");
};

export function generateJsonSchema(jsonDefinition: object): string {
  const escapedJsonString = JSON.stringify(jsonDefinition)
    .replace(/"/g, '\\"')
    .replace(/\{/g, "\\{")
    .replace(/\}/g, "\\}");

  return `"${escapedJsonString}"`;
}

export function cleanMarkdownCodeBlock(update: string): string {
  // Regular expression pattern to match markdown code blocks
  const pattern = /```([a-z]*)\n([\s\S]*?)```/g;

  // Match all code blocks in the markdown update
  const matches = [...update.matchAll(pattern)];

  // If code blocks were found
  if (matches.length > 0) {
    console.log("inside");
    let cleanedUpdate = "";
    for (const match of matches) {
      console.log("match", match);
      // Extract the language from the first line of the code block
      let language = match[1];

      // Extract the code from the rest of the code block
      const code = match[2].trimEnd();

      // Clean the code by removing the language and any leading or trailing whitespace
      let cleanedCode = code
        .replace(`\n${language}`, "")
        .replaceAll("```", "")
        .trim();

      cleanedCode = removeLeadingWhitespace(cleanedCode);

      cleanedUpdate += cleanedCode;
    }

    return cleanedUpdate;
  } else {
    console.log("outside");

    return update;
  }
}
